/* global axios */
import ApiClient from './ApiClient';

class AttachmentsAPI extends ApiClient {
  constructor() {
    super('attachments', { accountScoped: true });
  }

  transcribe(id) {
    return axios.patch(`${this.url}/${id}/transcribe`);
  }
}

export default new AttachmentsAPI();
